module.exports = require("swa-bootstrap-corporate-landing-home-page/metadata/metadata-data");